import Alpine from 'alpinejs';
import Swiper from 'swiper';
import { Navigation, Keyboard, Pagination, Thumbs } from 'swiper/modules';
import { SwiperOptions } from 'swiper/types';

// import styles bundle
import 'swiper/css';
import 'swiper/css/pagination';

document.addEventListener('alpine:init', () => {
    Alpine.data('initRealisationIntro', () => {
        return {
            swiperThumb: null as Swiper | null,
            swiper: null as Swiper | null,
            pictureIndex: 0,
            init() {
                const swiperParamsThumb: SwiperOptions = {
                    modules: [Navigation, Keyboard, Pagination],
                    //loop: true,
                    spaceBetween: 10,
                    slidesPerView: 'auto',
                    freeMode: true,
                    slideActiveClass: 'is-active',
                    watchSlidesProgress: true,
                    keyboard: {
                        enabled: true,
                    },
                };

                const swiperThumb = new Swiper(
                    this.$refs.swiperContainerThumb,
                    swiperParamsThumb,
                );
                this.swiperThumb = swiperThumb;

                const swiperParams: SwiperOptions = {
                    modules: [Navigation, Keyboard, Pagination, Thumbs],
                    init: false,
                    //loop: true,
                    centeredSlides: true,
                    spaceBetween: 16,
                    slidesPerView: 1,
                    keyboard: {
                        enabled: true,
                    },
                    navigation: {
                        prevEl: this.$refs.buttonPrev,
                        nextEl: this.$refs.buttonNext,
                    },
                    pagination: {
                        el: this.$refs.pagination,
                        clickable: true,
                    },
                    thumbs: {
                        swiper: swiperThumb,
                    },
                };
                const swiper = new Swiper(
                    this.$refs.swiperContainer,
                    swiperParams,
                );
                this.swiper = swiper;

                this.$nextTick(() => {
                    swiper.init();
                    swiperThumb.init();
                    this.slideToIndex()
                });
            },
            slideToIndex() {
                const galleryImgs = document.querySelectorAll('.galleryImg')
                let pictureIndex = 0
                galleryImgs.forEach(image => {
                    image.addEventListener('click', () => {
                        pictureIndex = Number(image.getAttribute('data-index'))
                        this.swiper?.slideTo(pictureIndex, 0, false);
                    })
                })
            }
        };
    });
});
